var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86768 1.67773C2.30247 2.14609 3.37061 3.0673 3.99658 3.70716C4.66654 4.39198 5.24409 4.74976 5.73151 5.21531C6.21908 5.68099 6.74436 6.09383 7.33002 6.59614C7.99139 7.16337 8.66 7.72251 9.40307 8.34815C10.1484 8.97572 10.7167 9.33406 11.2995 9.81308C11.8324 10.251 12.3159 10.7148 12.8266 10.9885C12.9332 11.0708 12.9967 11.2048 13.1021 11.2887C13.2075 11.3725 13.3528 11.4021 13.5026 11.4326",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.0958 11.8147C2.45414 11.6295 3.01787 10.8009 3.65377 10.1246C4.42348 9.30594 5.20467 8.38804 5.97521 7.6238C6.4522 7.15071 6.98855 6.54807 7.64994 5.89299C8.16231 5.38551 8.84601 4.93681 9.48245 4.47733C10.0859 4.04167 10.6843 3.56841 11.2036 3.12313C11.7229 2.67786 12.2403 2.23425 12.7597 1.78897C12.89 1.67724 13.0184 1.56717 13.2746 1.29556",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.29d7813dc3e6cd93e77cf27376c85bfc.svg";
export { ForwardRef as ReactComponent };